export enum FormStatusTab {
  ACTIVE = 'Active',
  DRAFTS = 'Draft',
  ARCHIVED = 'Archived',
  UNPUBLISHED = 'Unpublished',
}

export enum FormStatusFilter {
  ALL = 'All',
  PUBLISHED = 'Published',
  DRAFT = 'Draft',
  UNPUBLISHED = 'Unpublished',
  ARCHIVED = 'Archived',
}

export const STATUS_FILTER_OPTIONS: FormStatusFilter[] = [
  FormStatusFilter.ALL,
  FormStatusFilter.DRAFT,
  FormStatusFilter.PUBLISHED,
  FormStatusFilter.UNPUBLISHED,
  FormStatusFilter.ARCHIVED,
];

export function mapFilterToStatusTab(
  filter: FormStatusFilter,
): FormStatusTab | null {
  switch (filter) {
    case FormStatusFilter.PUBLISHED:
      return FormStatusTab.ACTIVE;
    case FormStatusFilter.DRAFT:
      return FormStatusTab.DRAFTS;
    case FormStatusFilter.UNPUBLISHED:
      return FormStatusTab.UNPUBLISHED;
    case FormStatusFilter.ARCHIVED:
      return FormStatusTab.ARCHIVED;
    case FormStatusFilter.ALL:
    default:
      return null;
  }
}

export function formStatusTabGridSlug(tab: FormStatusTab): string {
  if (tab === FormStatusTab.DRAFTS) {
    return 'draft';
  }
  return tab.toLowerCase();
}

export enum FormType {
  SPEAK_UP = 'Speak Up',
  CONFLICT_OF_INTEREST = 'Conflict of Interest',
}

export type FormManagementSection = 'SPEAK_UP' | 'COI';

export const DEFAULT_FORM_SECTION: FormManagementSection = 'SPEAK_UP';

export const FORM_SECTION_URL_SLUG: Record<FormManagementSection, string> = {
  SPEAK_UP: 'speak-up',
  COI: 'disclosure',
};

export interface FormData {
  id: string;
  title: string;
  category: string;
  categoryId?: number;
  country: string;
  description: string;
  languages: string;
  questionsCount: number;
  createdBy: string;
  createdAt: string;
  lastUpdated: string;
  status: FormStatusTab;
  type: FormType;
  countryCount: number;
}

export enum QuestionnaireStatusValue {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
  DRAFT = 'DRAFT',
}

export type BackendQuestionnaireStatus = QuestionnaireStatusValue;
